<h1 class='save-line-head' i18n='@@transaction-summary'>Sommario transazioni</h1>
<h4 i18n='@@text-transumm'>Per vedere le transazioni in ambiente di produzione accedi a Byond</h4>

<div class="menu-row">
        <a class="menu-link" href="https://merchant.worldlineitalia.it/login" target="_blank" rel="noopener noreferrer">
          <mat-card class="menu-card">
              <div class="menu-content">
                <mat-icon svgIcon='outlink' class="start-icon"></mat-icon>
                <span class="label" i18n='@@showtransaction-summary'>Vedi transazioni</span>
                <mat-icon class="end-icon">keyboard_arrow_right
                </mat-icon>
                </div>
            </mat-card>
      </a>
</div>
